import type { BinaryReader } from '../BinaryReader';

/**
 * Mirrors GameStars.Models.NetworkModels.DropdownOption (CommonNetworkModels.cs:10-42).
 * Wire order: Text(string), Value(short), MinPrice(int).
 * The client only ever decodes these (inside NewGameConfig), never sends them.
 */
export interface DropdownOption {
  text: string;
  value: number; // short
  minPrice: number; // int
}

export function decodeDropdownOption(r: BinaryReader): DropdownOption {
  return {
    text: r.getString(),
    value: r.getShort(),
    minPrice: r.getInt(),
  };
}
